import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Button,
  Dialog,
  Card,
  CardContent,
  CircularProgress,
} from "@material-ui/core";
import { Elements } from "react-stripe-elements";
import CardForm from "./cardForm";
import { subscribe } from "../../actions/subscribe";
import { openSnackBar } from "../../actions/snack-bar";
import "./styles.scss";

//["ROGX50082001", "ATIT50092001", "NCAR01092001", "COMP01012001", "ADMN01012001"];

var monthlyPrice = "";
var monthlyName = "";

var yearlyPrice = "";
var yearlyName = "";

function endOfWeek(date, days) {
  var lastday = date.getDate() - (date.getDay() - 1) + days;
  return new Date(date.setDate(lastday));
}

class MembershipModal extends Component {
  state = {
    page: 0,
    plan: null,
    loading: false,
    stripeMessage: "Please choose a plan below",
    stripeTitle: "Select a Plan",
    payType: 0,
  };

  async componentDidMount() {
    var registerCodeCheck = localStorage.getItem("registerCode");
    if (registerCodeCheck === "ATIT50092001") {
      yearlyPrice = "$47.50";
      yearlyName = "ATI Annual SSE";
      monthlyPrice = "$4.74";
      monthlyName = "ATI Monthly SSE";
      this.setState({});
    } else if (registerCodeCheck === "NCAR01092001") {
      yearlyPrice = "$47.50";
      yearlyName = "NCAR Annual SSE";
      monthlyPrice = "$4.74";
      monthlyName = "NCAR Monthly SSE";
      this.setState({});
    } else if (registerCodeCheck === "ROGX50082001") {
      yearlyPrice = "$39.99";
      yearlyName = "ROGX Annual SSE";
      monthlyPrice = "$4.99";
      monthlyName = "ROGX Monthly SSE";
      this.setState({});
    } else if (registerCodeCheck === "RBAR01092001") {
      yearlyPrice = "$47.50";
      yearlyName = "RBAR Annual SSE";
      monthlyPrice = "$4.74";
      monthlyName = "RBAR Monthly SSE";
      this.setState({});
    } else if (registerCodeCheck === "SCAR01092001") {
      yearlyPrice = "$39.99";
      yearlyName = "SCAR Annual SSE";
      monthlyPrice = "$3.99";
      monthlyName = "SCAR Monthly SSE";
      this.setState({});
    } else if (registerCodeCheck === "WARE01092001") {
      yearlyPrice = "$37.50";
      yearlyName = "WARE Annual SSE";
      monthlyPrice = "$3.75";
      monthlyName = "WARE Monthly SSE";
      this.setState({});
    } else if (registerCodeCheck === "CAOR010092001") {
      yearlyPrice = "$47.50";
      yearlyName = "CAOR Annual SSE";
      monthlyPrice = "$4.74";
      monthlyName = "CAOR Monthly SSE";
      this.setState({});
    } else if (registerCodeCheck === "Free4Me") {
      yearlyPrice = "$49.99";
      yearlyName = "Free4Me Annual SSE";
      monthlyPrice = "$4.99";
      monthlyName = "Free4Me Monthly SSE";
      this.setState({});
    } else if (registerCodeCheck === "OHAR01102001") {
      yearlyPrice = "$44.90";
      yearlyName = "OHAR Annual SSE";
      monthlyPrice = "$4.49";
      monthlyName = "OHAR Monthly SSE";
      this.setState({});
    } else if (registerCodeCheck === "NEREN10092001") {
        yearlyPrice = "$47.50";
        yearlyName = "NEREN Annual SSE";
        monthlyPrice = "$4.74";
        monthlyName = "NEREN Monthly SSE";
        this.setState({});
    } else {
      yearlyPrice = "$49.99";
      yearlyName = "Yearly";
      monthlyPrice = "$4.99";
      monthlyName = "Monthly";
      this.setState({});
    }
  }

  handleOptionChange = (e) => {
    if (e.target.value == 0) {
      this.setState({ payType: 0 });
    } else {
      this.setState({ payType: 1 });
    }
  };

  nextPage = (val) => {
    var registerCodeCheck = localStorage.getItem("registerCode");
    //['YEARLY PLAN', 'MONTHLY PLAN']
    if (registerCodeCheck === "ATIT50092001") {
      let plan = [
        "price_1HC9IfHoccCipyXrttgcM9E5",
        "price_1HC9IAHoccCipyXrXUalceDT",
      ][val];
      this.setState({
        page: 1,
        plan,
        stripeMessage: "Please enter your card below",
        stripeTitle: "Enter a Card",
      });
    } else if (registerCodeCheck === "NCAR01092001") {
      let plan = [
        "price_1HC9GZHoccCipyXrFiji4nGk",
        "price_1HC9G2HoccCipyXr0Tpfqq0H",
      ][val];
      this.setState({
        page: 1,
        plan,
        stripeMessage: "Please enter your card below",
        stripeTitle: "Enter a Card",
      });
    } else if (registerCodeCheck === "ROGX50082001") {
      let plan = [
        "price_1HC9AYHoccCipyXrZKUzQ19T",
        "price_1HC99jHoccCipyXrxmwbQp3u",
      ][val];
      this.setState({
        page: 1,
        plan,
        stripeMessage: "Please enter your card below",
        stripeTitle: "Enter a Card",
      });
    } else if (registerCodeCheck === "RBAR01092001") {
      let plan = [
        "price_1HKYGVHoccCipyXr387YBaC1",
        "price_1HKYF2HoccCipyXrdIS4NPol",
      ][val];
      this.setState({
        page: 1,
        plan,
        stripeMessage: "Please enter your card below",
        stripeTitle: "Enter a Card",
      });
    } else if (registerCodeCheck === "SCAR01092001") {
      let plan = [
        "price_1HKuwHHoccCipyXrtUMfKdUS",
        "price_1HKuwuHoccCipyXrsyHB8axk",
      ][val];
      this.setState({
        page: 1,
        plan,
        stripeMessage: "Please enter your card below",
        stripeTitle: "Enter a Card",
      });
    } else if (registerCodeCheck === "WARE01092001") {
      let plan = [
        "price_1HMNBZHoccCipyXrM65T5ysi",
        "price_1HMNAfHoccCipyXrlRD4yWkS",
      ][val];
      this.setState({
        page: 1,
        plan,
        stripeMessage: "Please enter your card below",
        stripeTitle: "Enter a Card",
      });
    } else if (registerCodeCheck === "CAOR010092001") {
      let plan = [
        "price_1HP6IrHoccCipyXr8sdu6dQc",
        "price_1HP6ICHoccCipyXrEPCBupuG",
      ][val];
      this.setState({
        page: 1,
        plan,
        stripeMessage: "Please enter your card below",
        stripeTitle: "Enter a Card",
      });
    } else if (registerCodeCheck === "Free4Me") {
      let plan = [
        "price_1HPtj4HoccCipyXrFeiZO3It",
        "price_1HPtilHoccCipyXrgSRRPNSO",
      ][val];
      this.setState({
        page: 1,
        plan,
        stripeMessage: "Please enter your card below",
        stripeTitle: "Enter a Card",
      });
    } else if (registerCodeCheck === "OHAR01102001") {
      let plan = [
        "price_1HWkKAHoccCipyXrMPCU3bZX",
        "price_1HWkKgHoccCipyXriobtkd6v",
      ][val];
      this.setState({
        page: 1,
        plan,
        stripeMessage: "Please enter your card below",
        stripeTitle: "Enter a Card",
      });
    } else if (registerCodeCheck === "NEREN10092001") {
        let plan = [
            "price_1JEwjnHoccCipyXryvcyQ0Az",
            "price_1JEwjFHoccCipyXrMqdI8qqO",
        ][val];
        this.setState({
            page: 1,
            plan,
            stripeMessage: "Please enter your card below",
            stripeTitle: "Enter a Card",
        });
    } else {
      let plan = ["yearly-plan", "monthly-plan"][val];
      this.setState({
        page: 1,
        plan,
        stripeMessage: "Please enter your card below",
        stripeTitle: "Enter a Card",
      });
    }
  };

  pay = () => {
    this.setState({ loading: true });
    const stripe = this.cardRef.props.stripe;
    const user = this.props.authentication.authenticatedUser;
    var trialDays = null;
    var registerCodeCheck = localStorage.getItem("registerCode");
    if (registerCodeCheck === "ATIT50092001") {
      trialDays = 15;
    } else if (registerCodeCheck === "NCAR01092001") {
      trialDays = 15;
    } else if (registerCodeCheck === "ROGX50082001") {
      trialDays = 30;
    } else if (registerCodeCheck === "RBAR01092001") {
      trialDays = 30;
    } else if (registerCodeCheck === "SCAR01092001") {
      trialDays = 30;
    } else if (registerCodeCheck === "WARE01092001") {
      trialDays = 30;
    } else if (registerCodeCheck === "CAOR010092001") {
      trialDays = 30;
    } else if (registerCodeCheck === "Free4Me") {
      trialDays = 30;
    } else if (registerCodeCheck === "OHAR01102001") {
        trialDays = 30;
    } else if (registerCodeCheck === "NEREN10092001") {
        trialDays = 30;
    } else {
      trialDays = null;
    }
    var newDate = new Date();
    var parsedDate = null;
    var obj = {
      user_id: user.id,
      plan: this.state.plan,
      name: user.first_name + " " + user.last_name,
      email: user.email,
      trial_end: parsedDate,
      registerCode: registerCodeCheck,
    };
    if (trialDays > 0) {
      parsedDate = Math.round(endOfWeek(newDate, trialDays).getTime() / 1000);
      obj.trial_end = parsedDate;
    } else {
      //console.log("NO TRIAL")
      obj = {
        user_id: user.id,
        plan: this.state.plan,
        name: user.first_name + " " + user.last_name,
        email: user.email,
        registerCode: registerCodeCheck,
      };
    }
    //console.log(obj)
    stripe
      .createToken()
      .then((res) => {
        obj.token = res.token.id;
        this.props
          .dispatch(subscribe(obj))
          .then((res) => {
            this.setState({ loading: false });
            if (res.message) {
              this.props.onSuccess();
            } else {
              this.props.dispatch(openSnackBar({ message: res.error }));
            }
          })
          .catch((err) => {
            console.log(err);
            this.props.dispatch(
              openSnackBar({ message: "Error purchasing membership" })
            );
            this.setState({ loading: false });
          });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
      });
  };

  render() {
    return (
      <Dialog open={true}>
        <Card className="membership-modal">
          <CardContent>
            <h2
              style={{
                margin: 0,
                marginTop: 10,
              }}
            >
              {this.state.stripeTitle}
            </h2>
            <p
              style={{
                margin: "0px 25px",
                color: "grey",
                textAlign: "center",
              }}
            >
              {this.state.stripeMessage}
            </p>
          </CardContent>
          {this.state.page === 0 ? (
            <div>
              <CardContent>
                <div className="flex">
                  <div className="flexGrow">
                    <form>
                      <div className="radio">
                        <label>
                          <input
                            type="radio"
                            value="0"
                            checked={this.state.payType === 0}
                            onChange={this.handleOptionChange}
                            style={{
                              marginRight: "20px",
                              width: "20px",
                              height: "20px",
                            }}
                          />
                          <a
                            href="/"
                            style={{
                              pointerEvents: "none",
                              textDecoration: "none",
                            }}
                          >
                            {yearlyName}
                          </a>
                          <p
                            style={{
                              margin: 0,
                            }}
                          >
                            pay annually for {yearlyPrice}/yr
                          </p>
                        </label>
                      </div>
                      <div className="radio">
                        <label>
                          <input
                            type="radio"
                            value="1"
                            checked={this.state.payType === 1}
                            onChange={this.handleOptionChange}
                            style={{
                              marginRight: "20px",
                              width: "20px",
                              height: "20px",
                            }}
                          />
                          <a
                            href="/"
                            style={{
                              pointerEvents: "none",
                              textDecoration: "none",
                            }}
                          >
                            {monthlyName}
                          </a>
                          <p
                            style={{
                              margin: 0,
                            }}
                          >
                            pay monthly for {monthlyPrice}/mth
                          </p>
                        </label>
                      </div>
                      <Button
                        className="thisButton"
                        variant="contained"
                        color="primary"
                        type="submit"
                        onClick={() => this.nextPage(this.state.payType)}
                      >
                        Submit
                      </Button>
                    </form>
                  </div>
                </div>
              </CardContent>
            </div>
          ) : (
            <Elements>
              <CardContent>
                <CardForm onRef={(ref) => (this.cardRef = ref)} />
              </CardContent>
            </Elements>
          )}
          <CardContent>
            <div className="flex">
              <div className="flexGrow" />{" "}
              {this.state.page === 1 && (
                <Button onClick={this.pay} variant="contained" color="primary">
                  {this.state.loading ? (
                    <CircularProgress
                      style={{
                        width: "25px",
                        height: "25px",
                        marginTop: "-2px",
                        color: "white",
                      }}
                    />
                  ) : (
                    "Purchase"
                  )}
                </Button>
              )}
            </div>
          </CardContent>
        </Card>
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};
const connector = connect(mapStateToProps);

export default connector(MembershipModal);
